module.exports = ":host{\n    padding: 10px;\n}"